module.exports = __webpack_public_path__ + "static/media/mc_symbol.1bd039ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/creditcard/mc_symbol.svg
// module id = 1777
// module chunks = 0